import { ProjectBriefsService } from '@inference.engine/workspace-api-client/web';
import { queryOptions } from '@tanstack/react-query';
import { workspaceHttp } from '@/lib/api/http-client';
import { BRIEFS_QUERY_KEYS } from './query-keys';

export interface BriefActivityParams {
  projectId: string;
  briefId: string;
}

export const briefActivityQueryOptions = (params: BriefActivityParams) =>
  queryOptions({
    queryKey: [...BRIEFS_QUERY_KEYS.detail(params.projectId, params.briefId), 'activity'] as const,
    queryFn: async ({ signal }) => {
      const response = await ProjectBriefsService.getActivity({
        client: workspaceHttp,
        path: { platformProjectId: params.projectId, briefId: params.briefId },
        signal,
      });

      if (!response.data) {
        throw new Error('Failed to load brief activity');
      }

      return response.data;
    },
    enabled: Boolean(params.projectId && params.briefId),
  });
